export enum TimeModels {
  LOCAL_TIME = 'localTime',
  VESSEL_TIME = 'vesselTime',
  VESSEL_POSITION = 'vesselPosition'
}

export function isVesselTime (model: TimeModels | string) {
  return model === TimeModels.VESSEL_TIME || model === TimeModels.VESSEL_POSITION
}

export function isPredefinedTimeModel (model: TimeModels | string) {
  return model === TimeModels.LOCAL_TIME || isVesselTime(model)
}
